module.exports = __webpack_public_path__ + "img/timeline_mainevent-7.6b15df08.jpg";